import { gql } from "@outschool/ui-apollo";

import {
  ActivityListingFragment,
  ListingCardFragment,
} from "../../Listings/graphql/fragments";

export default gql`
  query SearchListings(
    $searchFilters: SearchFilters!
    $offset: Int
    $limit: Int
    $cursor: String
    $skipRating: Boolean!
    $matchNames: Boolean
    $referrer: String
    $promotedRankingsEnabled: Boolean
    $promotedExperimentGroup: PromotedExperimentGroup
    $includeMatchingSections: Boolean
    $source: Boolean
    $anonymousId: String
    $searchUid: String
    $pageImpressionId: String
    $isFuzzySearchEnabled: Boolean
    $pageLocation: String
    $useCase: SearchUseCase
    $searchObjective: SearchObjective
    $disableAutoApplyFilterTypes: [AutoAppliedFilterType]
    $learnerPlanGoalUid: String
    $withRecentReviews: Boolean!
  ) {
    searchListings(
      searchFilters: $searchFilters
      cursor: $cursor
      offset: $offset
      limit: $limit
      matchNames: $matchNames
      referrer: $referrer
      promotedRankingsEnabled: $promotedRankingsEnabled
      promotedExperimentGroup: $promotedExperimentGroup
      includeMatchingSections: $includeMatchingSections
      source: $source
      anonymousId: $anonymousId
      searchUid: $searchUid
      pageImpressionId: $pageImpressionId
      isFuzzySearchEnabled: $isFuzzySearchEnabled
      pageLocation: $pageLocation
      useCase: $useCase
      searchObjective: $searchObjective
      disableAutoApplyFilterTypes: $disableAutoApplyFilterTypes
      learnerPlanGoalUid: $learnerPlanGoalUid
    ) {
      cursor
      total
      listings {
        ...ActivityListing_listing
        ...ListingCard_listing
        isAvailable
        score
        strategyScore
        strategy
        insertionId
      }
      autoAppliedFilters {
        gradeLevels
      }
    }
  }
  ${ActivityListingFragment}
  ${ListingCardFragment}
`;
